import { render } from "./UserGroupCreate.vue?vue&type=template&id=c91a349c&scoped=true"
import script from "./UserGroupCreate.vue?vue&type=script&lang=js"
export * from "./UserGroupCreate.vue?vue&type=script&lang=js"

import "./UserGroupCreate.vue?vue&type=style&index=0&id=c91a349c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91a349c"]])

export default __exports__